<script>
import {service, status, serviceColors, statusColors} from "../../../config/transaction"
import _ from 'lodash'

const columns = [
  {
    dataIndex: 'created_at',
    key: 'created_at',
    title: 'Date Time',
    width: 150,
    scopedSlots: {customRender: 'datetime'}
  }, {
    dataIndex: 'service_type',
    key: 'service',
    title: 'Service',
    width: 100,
    scopedSlots: {customRender: 'service'}
  }, {
    key: 'transaction',
    title: 'Transaction',
    scopedSlots: {customRender: 'transaction'}
  }, {
    key: 'subscriber',
    title: 'Subscriber',
    scopedSlots: {customRender: 'subscriber'}
  }, {
    key: 'price',
    title: 'Price',
    scopedSlots: {customRender: 'price'}
  }, {
    dataIndex: 'status',
    key: 'status',
    title: 'Status',
    width: 100,
    scopedSlots: {customRender: 'status'}
  }
]

export default {
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    serviceColors,
    statusColors,
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('report.transaction.live')
    },
    filteredServices() {
      return Object.keys(_.invert(service)).filter(o => !this.filters.service.includes(o))
    },
    filteredStatuses() {
      return Object.keys(_.invert(status)).filter(o => !this.filters.status.includes(o))
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('report.transaction.live.export') + '?' + this.$qs.stringify(params)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      service,
      status,
      items: {},
      loading: false,
      expand: false,
      modal: {
        visible: false,
        item: {}
      },
      filters: {
        q: null,
        page: 1,
        per_page: 10,
        date: [],
        status: [],
        service: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        page: 1,
        per_page: 10,
        q: '',
        products: [],
        service: [],
        status: [],
        date: []
      }
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    handleDownload() {
      window.open(this.exportUri, '_blank')
    }
  }
}
</script>
<template>
  <a-card size="small" type="inner" title="Live Transaction">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>

        <a-col :span="6">
          <a-select mode="multiple" placeholder="Status" v-model="filters.status">
            <a-select-option v-for="item in filteredStatuses" :key="item" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-col>

        <a-col :span="6">
          <a-select mode="multiple" placeholder="Services" v-model="filters.service">
            <a-select-option v-for="item in filteredServices" :key="item" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-col>

        <a-col :span="6">
          <product-autocomplete route-name="report.product" style="width: 100%"
                                @change="(item) => handleAutocomplete(item, 'products') "/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" @click="handleDownload"
                    :style="{ display: expand ? 'inline-block' : 'none'}"/>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">
        <h5 slot="datetime" slot-scope="datetime" class="text-center">
          {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <div slot="service" slot-scope="service" :style="{textAlign: 'center'}">
          <h4 :style="{ color: serviceColors[service] }">{{ service.toUpperCase() }}</h4>
        </div>

        <div slot="transaction" slot-scope="record">
          <template v-if="record.subscriber_id !== null">
            <h4 class="copyable">{{ record.subscriber_id }} // <small>{{ record.product.name }}</small>
              <a-button size="small" type="link" @click="copy(record.subscriber_id)" icon="copy"/>
            </h4>
            <div v-if="record.service_type === service.TRANSACTION_SERVICE_PAYMENT">
              <small class="copyable">
                # <code>{{ record.ref_num }}</code>
                <a-button size="small" type="link" @click="copy(record.ref_num)" icon="copy"/>
              </small>
            </div>
            <small class="copyable">
              UUID: <code>{{ record.id }}</code>
              <a-button size="small" type="link" @click="copy(record.id)" icon="copy"/>
            </small>
          </template>
          <template v-else>
            <div class="text-muted">
              <em>none</em>
            </div>
          </template>
        </div>

        <div slot="subscriber" slot-scope="record">
          <div v-if="record.subscriber_id !== null">
            <h4>{{ record.response.subscriber_name }}</h4>
            <h5>
              - <code>Subscriber ID: {{ record.response.subscriber_id }}</code><br>
              - <code>Alternate ID: {{ record.response.alternate_id }}</code><br>
              - <code>SN: {{ record.response.ref_id }}</code><br>
            </h5>
          </div>
          <div v-else>
            <div class="text-muted">
              <em>none</em>
            </div>
          </div>
        </div>

        <h4 slot="price" slot-scope="record" :style="{ color: record.price >= 0 ? '#237804' : '#a8071a'}">
          <template v-if="record.service_type !== service.TRANSACTION_SERVICE_DEPOSIT">
            {{ currency(record.price) }}
          </template>
          <template v-else>
            <div class="text-muted">
              <em>none</em>
            </div>
          </template>
        </h4>

        <div slot="status" slot-scope="status" class="text-center">
          <a-tag :color="statusColors[status]">{{ status.toUpperCase() }}</a-tag>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
